import Button from './Assets/Button.js'

export default function ConfirmationPage({Click, Close}) {
    return(
        <>
        {Click&&(
            <>
                <div id="C-Background" onClick={Close}/>
                <div id="Confirmation">
                <h1>Please check your booking information:</h1>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum. </p>
                <Button path="/success-page" name='Confirm' style='BP-Button'/>
                </div>
            </>
        )}
        </>
    )
}